import React from "react";
import { useTranslation } from "react-i18next";
import "./AssociatedMembers.css";
import AssociatedMembersForm from "../AssociatedMembersForm/AssociatedMembersForm";
import AssociatedMembersQR from "../AssociatedMembersQR/AssociatedMembersQR";

const AssociatedMembers = () => {
  const { t, i18n } = useTranslation();

  return (
    <div
      className="associated-members"
      key={i18n.language}
    >
      <h1 className="associated-members-header">
        {t("associatedMembers.header")}
      </h1>
      <p className="associated-members-description">
        {t("associatedMembers.description")}
      </p>
      <AssociatedMembersForm />
      <AssociatedMembersQR
        value="https://globalchic.club/associatedMembers"
        size={100}
        header={t("associatedMembers_qrCodeHeader")}
      />
    </div>
  );
};

export default AssociatedMembers;
